import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';
import { resolveFollowState } from '@/utils/followState';

import './styles/NewArtworkCard.css';

export default function NewArtworkCard({ data, user }) {
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  const isFollowing = resolveFollowState({ cacheHandler, userId: user?._id, imFollowing: user?.im_following });

  const claimedArtist  = data?.artwork_about?.artwork_artist;
  const galleryArtist  = data?.artwork_about?.artwork_gallery_artist;
  const artist         = claimedArtist || galleryArtist;

  // Avatar: user image if reclaimed; else the catalog artist profile image (if any)
  const artistImageId  = artist?.user_image?.image_id || artist?.artist_profile_image?.image_id;

  // Name: reclaimed profile display name → catalog name → safe fallback
  const artistName =
    claimedArtist?.user_name ??
    galleryArtist?.artist_name ??
    "Unknown artist";

  return (
    <div
      className={`new-artwork-card__container ${isFollowing ? 'following' : ''}`}
      onClick={() => navigate(`/artwork/${data.slug}`, {
        state: {
          from: true,
          artworkViewSource: {
            type: 'community',
            label: '',
          },
        }
      })}
    >
      <CardHeader
        image={user?.user_image?.image_id}
        profileType={user?.user_type}
        username={user?.user_username}
        onUserClick={() => navigate(`/user/${user?.user_username}`)}
        timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
        subtitle="uploaded a new artwork"
      />
      <ArtworkImage
        image={data?.artwork_media?.artwork_main_picture?.image_id}
        imageClassName="new-artwork-card__artwork-image"
        imageTemplateClassName="new-artwork-card__artwork-image"
      />
      <div className="new-artwork-card__artwork-info">
        {artistImageId && (
          <UserProfileImage
            image={artistImageId}
            typeOfProfile="artist"
            className="new-artwork-card__artist-image"
          />
        )}
        <div className="new-artwork-card__artwork-text">
          <Text className="new-artwork-card__artist-name font-size-small" paragraph>
            {artistName}
          </Text>
          <Text className="new-artwork-card__artwork-title font-size-medium" paragraph>
            {data?.artwork_about?.artwork_title}
          </Text>
        </div>
      </div>
    </div>
  );
}
